import React from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { addAdvice } from "../../../redux/SystemManagement/Advices/advicesSlice";
import StatusSelect from "../../../components/CustomSelect/StatusSelect";
import CustomInput from "../../../components/CustomInput/CustomInput";

function AdvicesActions() {
  const dispatch = useDispatch();
  const { addAdviceModalValues } = useSelector((state) => state.advices);

  const {
    formState: { errors, isValid },
    handleSubmit,
    reset,
    control,
  } = useForm({
    defaultValues: addAdviceModalValues,
  });

  const resetAddAdviceModalValues = () => {
    reset(addAdviceModalValues);
  };

  const handleAddAdvice = (data) => {
    dispatch(addAdvice(data));
    resetAddAdviceModalValues();
  };

  return (
    <>
      <nav className="uk-position-relative" aria-label="Breadcrumb">
        <ul className="uk-breadcrumb">
          <li>
            <span>إدارة نظام التحكم</span>
          </li>
          <li>
            <span aria-current="page">النصائح والإرشادات</span>
          </li>
        </ul>
        <button
          className="uk-button uk-button-primary uk-button-small uk-border-rounded uk-position-left"
          uk-toggle="target: #addAdviceModal"
        >
          <span className="uk-margin-small-left" uk-icon="plus"></span>
          إنشاء
        </button>
      </nav>

      {/* Add Advice Modal */}
      <div id="ModalOfAddAdvice">
        <div
          id="addAdviceModal"
          uk-modal="bg-close: false"
          container="#ModalOfAddAdvice"
        >
          <div className="uk-modal-dialog">
            <button
              className="uk-modal-close-default"
              type="button"
              uk-close=""
              onClick={resetAddAdviceModalValues}
            ></button>
            <div className="uk-modal-header uk-text-center">
              <h2 className="uk-modal-title">إضافة نصيحة</h2>
            </div>
            <div className="uk-modal-body">
              <form className="uk-grid-small uk-child-width-1-2" uk-grid="">
                <div>
                  <label className="uk-form-label uk-text-gray uk-text-bold">
                    العنوان بالعربي
                  </label>
                  <div className="uk-form-controls uk-margin-small-top">
                    <CustomInput
                      control={control}
                      name="nameAr"
                      error={errors.nameAr}
                    />
                  </div>
                </div>
                <div>
                  <label className="uk-form-label uk-text-gray uk-text-bold">
                    العنوان بالإنجليزي
                  </label>
                  <div className="uk-form-controls uk-margin-small-top">
                    <CustomInput
                      control={control}
                      name="nameEn"
                      error={errors.nameEn}
                    />
                  </div>
                </div>
                <div>
                  <label className="uk-form-label uk-text-gray uk-text-bold">
                    الوصف بالعربي
                  </label>
                  <div className="uk-form-controls uk-margin-small-top">
                    <CustomInput
                      control={control}
                      name="descriptionAr"
                      error={errors.descriptionAr}
                      textarea
                    />
                  </div>
                </div>
                <div>
                  <label className="uk-form-label uk-text-gray uk-text-bold">
                    الوصف بالإنجليزي
                  </label>
                  <div className="uk-form-controls uk-margin-small-top">
                    <CustomInput
                      control={control}
                      name="descriptionEn"
                      error={errors.descriptionEn}
                      textarea
                    />
                  </div>
                </div>
                <div>
                  <label className="uk-form-label uk-text-gray uk-text-bold">
                    الترتيب
                  </label>
                  <div className="uk-form-controls uk-margin-small-top">
                    <CustomInput
                      control={control}
                      name="order"
                      error={errors.order}
                      type="number"
                    />
                  </div>
                </div>
                <div>
                  <label className="uk-form-label uk-text-gray uk-text-bold">
                    الحالة
                  </label>
                  <div className="uk-form-controls uk-margin-small-top">
                    <Controller
                      name="status"
                      control={control}
                      render={({ field }) => (
                        <StatusSelect field={field} error={errors.status} />
                      )}
                      rules={{
                        validate: (v) =>
                          typeof v == "boolean" || "هذا الحقل مطلوب!",
                      }}
                    />
                  </div>
                </div>
              </form>
            </div>
            <div className="uk-modal-footer uk-text-left">
              <button
                className={`uk-button uk-button-secondary uk-margin-small-left uk-border-rounded${
                  isValid ? " uk-modal-close" : ""
                }`}
                type="button"
                onClick={handleSubmit(handleAddAdvice)}
              >
                إضافه
              </button>
              <button
                className="uk-button uk-button-primary uk-modal-close uk-border-rounded"
                type="button"
                onClick={resetAddAdviceModalValues}
              >
                إلغاء
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdvicesActions;
